export const environment = {
    production: true,
    sentry: "https://76bb8e331f67351b4e5bf6f011c3df5f@o4508081201020928.ingest.de.sentry.io/4508970398122064",
    sentryBackendURL: ["/^https:\\/\\/dev\\.internal\\.solar-sky\\.eu\\/api\\/.*/"],
    // Satellite basemap. Requires MML_API_KEY on the backend, which serves
    // the tiles through /api/maptiles. Coverage is Finland only.
    satelliteBasemap: true,
};
export const baseUrl = "https://dev.internal.solar-sky.eu"
export const integUrl = "https://dev.integration.solar-sky.eu"